import cx from 'classnames';

import {AnimatedText} from '#component/base';
import {Transition} from '#component/util';
import {useOnceEffect} from '#hook';
import {sprinkles} from '#style/sprinkles';

import {StepProps} from '../../StorySteps.types';
import {animTextLeft} from '../StorySteps.css';

export const Step6 = ({afterEnter, show}: StepProps) => {
  useOnceEffect(() => {
    // Since the transitions on this step are so short, enforce a minimum duration.
    setTimeout(() => {
      afterEnter?.();
    }, 1500);
  });

  return (
    <Transition className={sprinkles({position: 'absolute', inset: 0})} show={show}>
      <div className={cx(animTextLeft, sprinkles({flex: 'flex', dir: 'col', gap: 32}))}>
        <AnimatedText color="deepBurgundy" variant="heading3">
          Here’s the great news
        </AnimatedText>

        <AnimatedText color="deepBurgundy" variant="heading3">
          You can naturally lower your TallyAge™ by adopting the right lifestyle habits. More than
          90% of how you age is up to your lifestyle choices and environment.
        </AnimatedText>
      </div>
    </Transition>
  );
};
